import { css } from 'emotion';

export const buttons = css`
  display: flex;
  justify-content: flex-end;

  > :not(:first-child) {
    margin-left: 40px;
  }
`;

export const buttonsWrapper = css`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const buttonsWrapperOnEdit = css`
  ${buttonsWrapper} justify-content: space-between;
`;

export const trashIcon = css`
  margin-right: 10px;
`;
